import { status } from '../../config.ts'
import {
  clientTypesCatalog,
  promotionDetail1,
  promotionDetail2,
  promotionsPage1
} from './data.ts'
import { branchOfficesPage1 } from '@/__mocks__/modules/branchOffices/data.ts'
import { modelsCatalog } from '@/__mocks__/modules/brands/data.ts'
import { wait } from '@/__mocks__/util/async.ts'

export default [
  {
    method: 'GET',
    path: '/promotions?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, promotionsPage1]
    }
  },
  {
    method: 'GET',
    path: '/promotions/1',
    reply: async () => {
      await wait()
      return [status.ok, promotionDetail1]
    }
  },
  {
    method: 'GET',
    path: '/promotions/2',
    reply: async () => {
      await wait()
      return [status.ok, promotionDetail2]
    }
  },
  {
    method: 'POST',
    path: '/promotions',
    reply: async (config: { data?: string }) => {
      await wait()
      console.log('POST /promotions payload', config.data)
      return [status.ok, promotionDetail1]
    }
  },
  ...['1', '2'].flatMap((id) => [
    {
      method: 'PUT',
      path: `/promotions/${id}`,
      reply: async (config: { data?: string }) => {
        await wait()
        console.log(`PUT /promotions/${id} payload`, config.data)
        return [status.ok, promotionDetail1]
      }
    },
    {
      method: 'DELETE',
      path: `/promotions/${id}`,
      reply: async () => {
        await wait()
        return [status.ok]
      }
    }
  ]),
  {
    method: 'GET',
    path: '/client-types/catalog',
    reply: async () => {
      await wait()
      return [status.ok, clientTypesCatalog]
    }
  },
  {
    method: 'POST',
    path: '/branch-offices/catalog',
    reply: async () => {
      await wait()
      return [status.ok, branchOfficesPage1]
    }
  },
  {
    method: 'POST',
    path: '/models/catalog',
    reply: async () => {
      await wait()
      return [status.ok, modelsCatalog]
    }
  }
]
